import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const Footer: React.FC = () => {

const { theme } = useTheme();

  return (
    <footer className="pt-12 pb-12 border-t border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800/30">

      <div className="max-w-7xl mx-auto px-4">
        <div className="justify-between h-16 text-sm md:flex">

          <div
            className="flex flex-col sm:flex-row sm:items-center text-sm mb-2 sm:h-[50px]"
            style={{ color: 'var(--text-secondary)' }}
          >
            <div className="flex items-center">
              © {new Date().getFullYear()}
              {window.location.hostname === 'pikfc.com' ? (
                theme === 'dark' ? (
                  <img
                    src="/files/images/pikfc-logo.svg"
                    alt="Pik FC"
                    className="mx-2"
                    style={{ width: '48px', height: 'auto', display: 'inline-block', verticalAlign: 'middle' }}
                  />
                ) : (
                  <img
                    src="/files/images/pikfc-logo-black.svg"
                    alt="Pik FC"
                    className="mx-2"
                    style={{ width: '48px', height: 'auto', display: 'inline-block', verticalAlign: 'middle' }}
                  />
                )
              ) : (
                theme === 'dark' ? (
                  <img
                    src="/files/images/predictorpro-logo.svg"
                    alt="PredictorPro"
                    className="mx-2"
                    style={{ width: '120px', height: 'auto', display: 'inline-block', verticalAlign: 'middle' }}
                  />
                ) : (
                  <img
                    src="/files/images/predictorpro-logo-black.svg"
                    alt="PredictorPro"
                    className="mx-2"
                    style={{ width: '120px', height: 'auto', display: 'inline-block', verticalAlign: 'middle' }}
                  />
                )
              )}
            </div>
            <span>
              All rights reserved{" | "}Supported by&nbsp;
              <a
                href="https://www.squadal.com"
                target="_blank"
                className="underline opacity-70 hover:opacity-100 transition-opacity"
                style={{ color: 'var(--text-primary)' }}
                rel="noopener noreferrer"
              >
                Squadal
              </a>
              &nbsp;and&nbsp;
              <a
                href="https://www.tournito.com"
                target="_blank"
                className="underline opacity-70 hover:opacity-100 transition-opacity"
                style={{ color: 'var(--text-primary)' }}
                rel="noopener noreferrer"
              >
                Tournito
              </a>
            </span>
          </div>
        
          <div className="items-center text-sm mb-2 md:flex" style={{ height: '50px'}}>
            <span>
              
              <Link 
                to="/contact" 
                className="opacity-70 hover:opacity-100 transition-opacity"
                style={{ color: 'var(--text-primary)' }}
              >
                Contact
              </Link>

              <span className="opacity-50" style={{ color: 'var(--text-primary)' }}> | </span>
              
              <Link 
                to="/rules" 
                className="opacity-70 hover:opacity-100 transition-opacity"
                style={{ color: 'var(--text-primary)' }}
              >
                Rules
              </Link>

              <span className="opacity-50" style={{ color: 'var(--text-primary)' }}> | </span>

              <Link 
                to="/privacy-policy" 
                className="opacity-70 hover:opacity-100 transition-opacity"
                style={{ color: 'var(--text-primary)' }}
              >
                Privacy Policy
              </Link>

              <span className="opacity-50" style={{ color: 'var(--text-primary)' }}> | </span>
              <Link 
                to="/terms" 
                className="opacity-70 hover:opacity-100 transition-opacity"
                style={{ color: 'var(--text-primary)' }}
              >
                Terms of Service
              </Link>
              </span>
            </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer; 